import { Accesorio } from "./accesorio";

export class TipoProductoCategoria {
    constructor(
        public id: number | string = null,
        public IdCategoria: number | string = null,
        public descripcion: string = '',
        public tipoOferta: number | string = null
    ) { }
}

export class TipoProducto {
    constructor(
        public id?: number,
        public descripcion?: string,
        public observacion?: string,
        public accesorios: Accesorio[] = <Accesorio[]>[],
        public categoria: TipoProductoCategoria = new TipoProductoCategoria(),
        
    ) { }

    /**
     * Busca el accesorio recibido entre los accesorios del dato y retorna true si lo encuentra
     * @param accesorio
     * @returns boolean true si el dato contiene el accesorio, false otro caso
     */
    hasAccesorio(accesorio: Accesorio) {
        var index = this.accesorios.length;
        while (index--) {
            if (this.accesorios[index].IdAccesorio == accesorio.IdAccesorio) {
                return true;
            }
        }

        return false;
    }
}
